var ru = {
	"neptune.Button.loadingAriaLabel": "загрузка",
	"neptune.Chips.ariaLabel": "Очистить {choice}",
	"neptune.ClearButton.ariaLabel": "Очистить",
	"neptune.CloseButton.ariaLabel": "Закрыть",
	"neptune.DateInput.day.label": "День",
	"neptune.DateInput.day.placeholder": "ДД",
	"neptune.DateInput.month.label": "Месяц",
	"neptune.DateInput.year.label": "Год",
	"neptune.DateInput.year.placeholder": "ГГГГ",
	"neptune.DateLookup.day": "день",
	"neptune.DateLookup.goTo20YearView": "Перейти к обзору 20 лет",
	"neptune.DateLookup.month": "месяц",
	"neptune.DateLookup.next": "далее",
	"neptune.DateLookup.previous": "назад",
	"neptune.DateLookup.selected": "выбрано",
	"neptune.DateLookup.twentyYears": "20 лет",
	"neptune.DateLookup.year": "год",
	"neptune.FlowNavigation.back": "вернуться к предыдущему шагу",
	"neptune.Info.ariaLabel": "Подробнее",
	"neptune.Label.optional": "(необязательно)",
	"neptune.Link.opensInNewTab": "(откроется в новой вкладке)",
	"neptune.MoneyInput.Select.placeholder": "Выберите вариант...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Выберите валюту",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Выберите вариант...",
	"neptune.Select.searchPlaceholder": "Поиск...",
	"neptune.SelectInput.noResultsFound": "Ничего не найдено",
	"neptune.SelectOption.action.label": "Выбрать",
	"neptune.SelectOption.selected.action.label": "Изменить выбранный вариант",
	"neptune.StatusIcon.iconLabel.error": "Ошибка:",
	"neptune.StatusIcon.iconLabel.information": "Информация:",
	"neptune.StatusIcon.iconLabel.pending": "В ожидании:",
	"neptune.StatusIcon.iconLabel.success": "Готово:",
	"neptune.StatusIcon.iconLabel.warning": "Внимание:",
	"neptune.Summary.statusDone": "Этап завершен",
	"neptune.Summary.statusNotDone": "Этап к выполнению",
	"neptune.Summary.statusPending": "Этап в процессе",
	"neptune.Table.actionHeader": "Действие",
	"neptune.Table.emptyData": "Ничего не найдено",
	"neptune.Table.loaded": "Данные таблицы загружены",
	"neptune.Table.loading": "Данные таблицы загружаются",
	"neptune.Table.refreshPage": "Обновить страницу",
	"neptune.Upload.csButtonText": "Загрузить другой файл?",
	"neptune.Upload.csFailureText": "Загрузка не удалась. Пожалуйста, попробуйте снова",
	"neptune.Upload.csSuccessText": "Загрузка завершена!",
	"neptune.Upload.csTooLargeMessage": "Пожалуйста, загрузите файл размером менее {maxSize} Мб",
	"neptune.Upload.csWrongTypeMessage": "Тип файла не поддерживается. Пожалуйста, попробуйте еще раз с другим файлом",
	"neptune.Upload.psButtonText": "Отменить",
	"neptune.Upload.psProcessingText": "Загружаем...",
	"neptune.Upload.retry": "Повторить попытку",
	"neptune.Upload.usButtonText": "Или выберите файл",
	"neptune.Upload.usDropMessage": "Перетащите файл, чтобы начать загрузку",
	"neptune.Upload.usPlaceholder": "Перетащите файл размером не более {maxSize} Mб",
	"neptune.UploadButton.allFileTypes": "Все типы файлов",
	"neptune.UploadButton.dropFiles": "Перетащите файл, чтобы начать загрузку",
	"neptune.UploadButton.instructions": "{fileTypes}, не превышающий {size} MB",
	"neptune.UploadButton.maximumFiles": "Макс. количество файлов: {maxFiles}.",
	"neptune.UploadButton.uploadFile": "Загрузить файл",
	"neptune.UploadButton.uploadFiles": "Загрузить файлы",
	"neptune.UploadInput.deleteModalBody": "Удаление этого файла приведет к его удалению из нашей системы.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Отменить",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Удалить",
	"neptune.UploadInput.deleteModalTitle": "Уверены, что хотите удалить этот файл?",
	"neptune.UploadInput.fileIsTooLarge": "Файл слишком большой",
	"neptune.UploadInput.fileTypeNotSupported": "Тип файла не поддерживается",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "К сожалению, эта загрузка не удалась, так как одновременно мы можем принять только {maxFilesAllowed} файла(-ов).",
	"neptune.UploadItem.deleting": "Удаляется...",
	"neptune.UploadItem.removeFile": "Удалить файл {filename}",
	"neptune.UploadItem.uploaded": "Завершено",
	"neptune.UploadItem.uploadedFile": "Загруженный файл",
	"neptune.UploadItem.uploading": "Загрузка...",
	"neptune.UploadItem.uploadingFailed": "Загрузка не удалась"
};

export { ru as default };
//# sourceMappingURL=ru.json.mjs.map
